import { useQuery } from "@tanstack/react-query";
import { DataHealthService } from "@gen/tracker/v1/data_health_connect";
import type { DataHealth } from "@gen/tracker/v1/data_health_pb";

import { createClient } from "@/lib/connect";
import { useTrackerRoles } from "@/lib/permissions";

const client = createClient(DataHealthService);

/** One minute: the footer and the rail badge poll it on every screen. */
export const DATA_HEALTH_POLL_MS = 60_000;

/**
 * «Can I trust today's numbers?» — the workspace's GetDataHealth. The footer
 * line and the rail's «Здоровье данных» badge read it; one query, shared.
 */
export function useDataHealth() {
  // The workspace's data health is the company's, not a «своё» person's.
  const { isSelf } = useTrackerRoles();
  return useQuery({
    queryKey: ["data-health"] as const,
    enabled: !isSelf,
    refetchInterval: DATA_HEALTH_POLL_MS,
    staleTime: DATA_HEALTH_POLL_MS / 2,
    queryFn: async (): Promise<DataHealth | undefined> => (await client.getDataHealth({})).health,
  });
}

/** Issues worth a badge: money is wrong, or numbers are late. Pure. */
export function attentionCount(h: DataHealth | undefined): number {
  return (h?.issues ?? []).filter((i) => i.severity === "money" || i.severity === "warn").length;
}

/** Postbacks the journal holds that matched no click, across networks. Pure. */
export function postbacksWithoutClick(h: DataHealth | undefined): number {
  return (h?.postbacksWithoutClick ?? []).reduce((n, p) => n + Number(p.count), 0);
}
